module.exports = __webpack_public_path__ + "assets/img/banner-redarea.924a0469.jpg";